import { Component } from '@angular/core';
import { LogoComponent } from '../svg/logo';
import { ArrowDownComponent } from '../svg/arrow-down';
import { Search } from "../search/search";

@Component({
  selector: 'app-header',
  imports: [LogoComponent, ArrowDownComponent, Search],
  templateUrl: './header.html',
  styleUrl: './header.scss'
})
export class Header {

  navToggle() {
  }
  hideNav() {

  }

  showModal = false;

  setShowModal(show: boolean) {
    // Logic to show or hide modal
    console.log('Modal visibility set to:', show);  
    this.showModal = show;
  }
}
